import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App  from './App/App';
import { store } from './_helpers';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);